import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'
import { motion } from 'framer-motion'

const StarContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
`

const Star = styled(motion.div)`
  position: absolute;
  width: 2px;
  height: 2px;
  background: ${props => props.theme.colors.text.primary};
  border-radius: 50%;
`

const StarField = () => {
    const containerRef = useRef()

    useEffect(() => {
        const container = containerRef.current
        if (!container) return

        // Generate stars
        for (let i = 0; i < 100; i++) {
            const star = document.createElement('div')
            star.style.position = 'absolute'
            star.style.width = '2px'
            star.style.height = '2px'
            star.style.background = 'white'
            star.style.borderRadius = '50%'
            star.style.left = Math.random() * 100 + '%'
            star.style.top = Math.random() * 100 + '%'
            star.style.animation = `twinkle ${Math.random() * 3 + 2}s infinite`
            star.style.animationDelay = Math.random() * 3 + 's'
            container.appendChild(star)
        }

        // Add CSS animation
        const style = document.createElement('style')
        style.textContent = `
      @keyframes twinkle {
        0%, 100% { opacity: 0.3; }
        50% { opacity: 1; }
      }
    `
        document.head.appendChild(style)

        return () => {
            document.head.removeChild(style)
        }
    }, [])

    return <StarContainer ref={containerRef} />
}

export default StarField